/**
 * Validates swedish personal numbers (social security numbers)
 * (among other "luhn" things)
 *
 * @param {string} value
 * @param {boolean} [ignoreSpaces=true]
 * @return {*}
 */
const luhnCheck = (value: string, ignoreSpaces = true) => {
    const num = ignoreSpaces ? value.replace(/\s*/g, "") : value;

    const arr = num.split("").reverse().map(Number);
    const lastDigit = arr.shift() ?? 0;
    let sum = arr.reduce(
        (acc, val, i) =>
            i % 2 !== 0 ? acc + val : acc + ((val *= 2) > 9 ? val - 9 : val),
        0,
    );
    sum += lastDigit;
    return sum % 10 === 0;
};

export { luhnCheck };
